import { render, staticRenderFns } from "./HotkeysModal.vue?vue&type=template&id=31a9f839&scoped=true"
import script from "./HotkeysModal.vue?vue&type=script&lang=js"
export * from "./HotkeysModal.vue?vue&type=script&lang=js"
import style0 from "./HotkeysModal.vue?vue&type=style&index=0&id=31a9f839&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a9f839",
  null
  
)

export default component.exports